import moment from 'moment';

const formatMailbox = data => {
	data.updatedAt = moment(data.updatedAt).format('DD-MM-YYYY');
	data.createdAt = moment(data.createdAt).format('DD-MM-YYYY');
	return data;
};

export default {
	setMailBoxes: (state, mailBoxes) => (state.mailBoxes = mailBoxes.map(formatMailbox)),
};
